<script>
    //import Menu from "../../components/Menu.svelte";
    import { getRole, getUserId } from "../../js/localInfo";
    import { post } from "../../js/labit-connection";
    // import MenuMyProfile from "../../components/MenuMyProfile.svelte";
    import AbsenceItem from "../../components/AbsenceItem.svelte";
    import TimeReports from "./TimeReports.svelte";
    // import Calendar from "../../components/CalendarPicker/CalendarPicker.svelte";
    //import { onMount } from "svelte";
    //import { each } from "svelte/internal";

    let myRole = getRole(); 
    let myId = getUserId();

    if (myRole !== "Admin") {
        location.href = "/skylab-main";
    }

    let visible = "absences";
    let visibleReport = "projectTime";

    let absences = [];

    const getAbsences = async () => {
        let query = `select a.id, p.name as user, at.name as type, a.description, a.start, a.end, a.half, a.accepted_by_team_leader, a.accepted_by_ceo, a.requested_time, at.approvable 
            from people as p inner join absences as a on a.user_id = p.contact_id
            inner join absence_type as at on a.absence_type_id = at.id order by a.requested_time desc; `;
        
        let unformattedAbsences = await post( query );

        let res = [];
        unformattedAbsences.forEach(e => {
            let accepted_by_team_leader = "", accepted_by_ceo = "", approvable = "";

            e.approvable !== "1" ? ( accepted_by_team_leader = "-", accepted_by_ceo = "-", approvable = "No" ) : ( accepted_by_team_leader = yesOrNo(e.accepted_by_team_leader), accepted_by_ceo = yesOrNo(e.accepted_by_ceo), approvable = "Yes" );

            res = [...res, {id: e.id, user: e.user, type: e.type, description: e.description, start: e.start, end: e.end, half: e.half,
                accepted_by_team_leader: accepted_by_team_leader, accepted_by_ceo: accepted_by_ceo,
                requested_time: e.requested_time, approvable: approvable}
            ];
        });

        return res;
    }

    let promise = getAbsences();

	const handleClick = () => {
		promise = getAbsences();
	}

    const yesOrNo = (num) => { return num === "1" ? "Yes" : (num === "-1" ? "No" : "-") };
    /*
    onMount(async () => {
        await getAbsences();
    });
    */

</script>


<div class="dialogContent">
    <div class="main flex">
        <div class="left-menu white-container flex-col">
            <button class="left-menu-btn {visible === "absences" ? "btn-selected" : ""}" on:click={ () => visible="absences"}>Absences</button>
            <button class="left-menu-btn {visible === "reports" ? "btn-selected" : ""}" on:click={ () => visible="reports"}>Reports</button>
            <button class="left-menu-btn {visible === "3"}" on:click={ () => visible="3"}>-</button>
            <button class="left-menu-btn {visible === "4"}" on:click={ () => visible="4"}>-</button>
        </div>
        <div class="principal white-container flex-col flex-center">

            {#if visible === "absences"}

                <span class="title">Absence requests</span>
                <table class="w-100" style="table-layout: fixed;">
                    <tr class="table-header">
                        <th>Name</th>
                        <th>Type</th>
                        <th>Start</th>
                        <th>End</th>
                        <th>Accepted by team leader</th>
                        <th>Accepted by Elvira</th>
                        <th>Requested on</th>
                        <th>Approvable</th>
                    </tr>
                    {#await promise}
                        <p>...waiting</p>
                    {:then absences}
                        {#each absences as {id, user, type, description, start, end, half, accepted_by_team_leader, accepted_by_ceo, requested_time, approvable}, i}
                            <AbsenceItem
                                {id}
                                {user}
                                {type}
                                descriptionTooltip={description}
                                {start}
                                {end}
                                {half}
                                {accepted_by_team_leader}
                                {accepted_by_ceo}
                                {requested_time}
                                {approvable}
                                position={i}
                                on:dispatchedClick={handleClick}
                            />
                        {/each}
                    {:catch error}
                        <p style="color: red">{error.message}</p>
                    {/await}
                
                </table>

            {:else if visible === "reports"}
                <span class="title">Reports</span>
                <TimeReports />
            {:else if visible === "3"}
                <div></div>
            {:else if visible === "4"}
                <div></div>
            {/if}
        </div>
    </div>
</div>

<svelte:head>
<title>SkyLab - Inventory</title>
<style>

    tr, th, td {
        height: 40px;
        color: #6a6a6a;
    }
    
    .table-header {
        background-color: #eaeff5;
	}

    div.dialogContent {
        background-color: var(--labit-background-gray);
        width: 1640px;
        height: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-top: 20px;
        flex-direction: column;
    }

    .main {
        height: 98%;
        width: 100%;
        flex-direction: row;
        justify-content: space-between;
    }

    .left-menu {
        height: 100%;
        width: 10%;
        padding: 20px;
        padding-top: 60px;
    }

    .principal {
        height: 100%;
        width: 89.5%;
        padding: 30px;
        overflow: auto;
    }

    .flex {
        display: flex;
    }

    .flex-col {
        display: flex;
        flex-direction: column;
    }

    .flex-center {
        align-items: center;
    }
    
	.pointer {
        cursor: pointer;
	}

	.white-container {
		background-color: white;
		border-radius: 30px;
	}

    .wh-100 {
        width: 100% !important;
        height: 100% !important;
    }

    .w-100 {
        width: 100% !important;
    }

    .h-100 {
        height: 100% !important;
    }

    button {
        margin: 0;
    }

    .left-menu-btn {
        color: #696969;
        background-color: #ffffff;
        outline: none;
        border: 1px solid #e6e6e6;
        height: 50px;
        border-radius: 10px;
        margin-bottom: 1rem;
    }

    .btn-selected {
        background-color: #d7e1ea !important;
        border: none;
    }

    .title {
        padding: 0 20px 20px;
        font-size: 2rem;
        color: #545454;
    }
    

	[data-tooltip] {
		position: relative;
		z-index: 2;
		display: block;
	}

	[data-tooltip]:before,
	[data-tooltip]:after {
		visibility: hidden;
		opacity: 0;
		pointer-events: none;
		transition: .2s ease-out;
		transform: translate(-50%, 5px)
	}

	[data-tooltip]:before {
		position: absolute;
		bottom: 100%;
		left: 50%;
		margin-bottom: 5px;
		padding: 7px;
		width: 100%;
		min-width: 70px;
		max-width: 250px;
		-webkit-border-radius: 3px;
		-moz-border-radius: 3px;
		border-radius: 3px;
		background-color: #000;
		background-color: hsla(0, 0%, 20%, 0.9);
		color: #fff;
		content: attr(data-tooltip);
		text-align: center;
		font-size: 14px;
		line-height: 1.2;
		transition: .2s ease-out
	}

	[data-tooltip]:after {
		position: absolute;
		bottom: 100%;
		left: 50%;
		width: 0;
		border-top: 5px solid #000;
		border-top: 5px solid hsla(0, 0%, 20%, 0.9);
		border-right: 5px solid transparent;
		border-left: 5px solid transparent;
		content: " ";
		font-size: 0;
		line-height: 0;
	}

	[data-tooltip]:hover:before,
	[data-tooltip]:hover:after {
		visibility: visible;
		opacity: 1;
		transform: translate(-50%, 0)
	}
	[data-tooltip=false]:hover:before,
	[data-tooltip=false]:hover:after {
		visibility: hidden;
		opacity: 0;
	}
    
	.pointer {
        cursor: pointer;
	}

    /*

    .options {
        height: 40px;
        justify-content: space-evenly;
    }
    
	.options button {
        color: #696969;
        background-color: #ffffff;
        outline: none;
        border: 1px solid #e6e6e6;
		border-radius: 6px;
        width: 150px;
	}
    */

</style>
</svelte:head>